<template>
	<div>
		<!-- 修改个人信息 -->
		<el-dialog width="457px" :visible.sync="show" @open="userOpen()" :append-to-body="true" @close="close()" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="set_info_dialog">
				<div class="set_info_top">
					<div class="set_info_top_title">
						Personal Information
					</div>
					<div class="set_info_top_close">
						<img @click="close()" class="set_info_dialog_close_icon"
							src="../../../assets/icons/close_icon2.png" alt="" />
					</div>
				</div>
				<div class="set_info_content" v-loading="loading1">
					<div class="set_info_avatar_box">
						<div class="set_info_my_avatar">
							<img class="set_info_avatar" :src="userInfo.avatar" alt="" />
						</div>
						<div class="set_info_avatar_list hide_scroll_bars" v-loading="loading">
							<div class="set_info_avatar_item" v-for="(item,index) in avatarList" :key="index"
								:class="(index+1)%5==0?'mar_r0':''">
								<img :src="item" @click="clickAvatar(item)" class="set_info_avatar_item_img" alt="" />
							</div>
						</div>
					</div>

					<div class="header_wallet_paytype">
						<div class="header_wallet_paytype_title">
							Input your name
						</div>
						<div class="header_wallet_paytype_input">
							<el-input clearable v-model="userInfo.nickName" />
						</div>
					</div>
					<div class="set_info_remark">
						Do not use special symbols,otherwise your nickname may not <br>
						be supported
					</div>

					<div @click="clickSetUserInfo" class="def_btn mar_t30" style="width: 100%;">
						Save
					</div>

				</div>


			</div>
		</el-dialog>



	</div>
</template>

<script>
	import {
		mapState,
	} from 'vuex';

	export default {
		name: 'setUserInfo',
		computed: {
			...mapState(['user', 'token']), // 映射 user 模块下的 userInfo 状态
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				loading1:false,
				loading: false,

				avatarList: [],

				userInfo: {
					avatar: '',
					nickName: '',

				}
			}
		},
		mounted() {
			// this.userOpen()
		},
		methods: {
			close() {
				this.$emit('close', false)
			},
			userOpen() {
				this.userInfo.avatar = JSON.parse(JSON.stringify(this.user.avatar))
				this.userInfo.nickName = JSON.parse(JSON.stringify(this.user.nickName))
				this.getAvatarList()
			},
			getAvatarList() {
				this.loading = true
				setTimeout(() => {
					this.loading = false
				}, 2000)
				this.$api.getAvatarList({}).then(res => {
						this.avatarList = res.data
					})
					.finally(() => {
						this.loading = false
					})
			},
			// 点击头像列表
			clickAvatar(item) {
				this.userInfo.avatar = item
			},
			clickSetUserInfo() {
				const reg = /^[A-Za-z0-9]+$/
				 if (!this.userInfo.nickName) {
					this.$use.msg('Please input your name', 'error')
					return
				}else if(!reg.test(this.userInfo.nickName)){
					this.$use.msg('Nicknames can only contain letters and numbers.', 'error')
					return
				}
				this.loading1 = true
				setTimeout(() => {
					this.loading1 = false
				}, 2000)
				this.$api.setUserInfo(this.userInfo).then(res => {
						this.$use.msg('Profile Edited', 'success')
						this.$store.dispatch('GetInfo')
					})
					.finally(() => {
						this.loading1 = false
					})
			},


		},
	}
</script>


<style scoped lang="scss">
	.set_info_dialog {
		position: absolute;
		left: 0;
		top: 0;
		width: 457px;
		min-width: 437px;
		min-height: 678px;
		overflow-y: auto;
		background: #1F242F;
		border-radius: 10px;
		border: 1px solid;

	}

	.set_info_top {
		position: relative;
		width: 457px;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 20px;
		box-sizing: border-box;
		color: #F0F0F0;
		font-size: 24px;
		background: #161A22;
		border-radius: 18px 18px 0 0;
	}

	.set_info_top_title {}

	.set_info_top_close {
		width: 43.38px;
		height: 100%;
		display: flex;
		align-items: center;
	}

	.set_info_dialog_close_icon {
		position: absolute;
		top: 20px;
		right: 20px;
		width: 43.38px;
		height: 28.92px;
		cursor: pointer;
	}

	.set_info_content {
		width: 100%;
		box-sizing: border-box;
		padding: 35px 17px 32px;
	}

	.set_info_avatar_box {
		width: 100%;
	}
	
	.set_info_my_avatar{
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.set_info_avatar {
		width: 83px;
		height: 83px;
		border-radius: 50%;
	}

	.set_info_avatar_list {
		width: 100%;
		height: 242px;
		background: #1D2027;
		border-radius: 12px;
		box-sizing: border-box;
		padding: 16px 14px 1px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		margin-top: 13px;
		overflow-y: auto;
	}

	.set_info_avatar_item {
		margin: 0 23px 15px 0;
		width: 60px;
		height: 60px;
	}

	.set_info_avatar_item_img {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		cursor: pointer;
	}

	.set_info_remark {
		font-weight: 400;
		font-size: 14px;
		color: #526481;
		line-height: 13px;
		text-align: left;
		margin-top: 12px;
	}
</style>